// file suffix
export const fileSuffix = [
    'xls', 'xlt', 'et', 'xlsx', 'xltx', 'csv', 'xlsm', 'xltm' ,
    'doc', 'dot', 'wps', 'wpt', 'docx', 'dotx', 'docm', 'dotm' ,
    'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps' ,
    'pdf'
];